export default {
    AREA: 'area',
    AUTO_AREA: 'auto_area',
    DEPART: 'depart'
  }



// WEBPACK FOOTER //
// ./src/store/const.js